// AI-ASSISTED: generated with claude-code on 2026-08-28, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { ServiceConnectionAccountCard } from './ServiceConnectionAccountCard';

const serviceConnectionAccountCard = EntityCardBlueprint.make({
  name: 'service-connection-account',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { ServiceConnectionAccountCard } = await import('./ServiceConnectionAccountCard');
      return <ServiceConnectionAccountCard />;
    },
  },
});

export const serviceConnectionAccountCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [serviceConnectionAccountCard],
});
